/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

 import ServiceConstant from "@/app/core/ServiceConstant";
 import MainService from "@/app/services/MainService";
 
 export default class MedicalPracticeService extends MainService {

   static cancelMedicalAppointment(params) {
     return this.postSEC(ServiceConstant.PATIENT_CANCEL_APPOINTMENT, params);
   }
 }
 